<template>
  <div>
    <Table :columns="columns" :data="planSales" :isAccessible="true" @view="redirectToDetails">
      <template #plan="{ row }">
        <div class="flex flex-col">
          <span>
            <span class="font-medium">{{ row.title }}</span>
            à
            <span class="font-medium">{{ formatPrice(row.price) }}{{ byMonth(row) }}</span>
          </span>
          <span class="font-light italic">{{ row.id }} - {{ row.purchaseDate }}</span>
          <span v-if="row.orderReferenceId" class="font-light italic">
            Numéro de commande : {{ row.orderReferenceId }}
          </span>
          <span class="font-light italic" v-if="isCancelled(row)">Résilié le {{ row.cancellationDate }}</span>
        </div>
        <div class="flex flex-col md:hidden">
          <span class="font-light italic">
            {{ row.product.title }} ({{ row.product.category }}) à
            {{ formatPrice(row.product.price) }}
          </span>
          <span class="font-light italic">{{ row.customer.email }}</span>
        </div>
      </template>

      <template #product="{ row }">
        <span>{{ row.product.title }}</span>
        <div class="flex">
          <span class="font-light italic mr-2">{{ formatPrice(row.product.price) }}</span>
          -
          <span class="ml-2 font-light italic">{{ row.product.category }}</span>
        </div>
      </template>

      <template #customer="{ row }">
        <div class="flex flex-col">
          <span>{{ row.customer.email }}</span>
          <span class="font-light italic">{{ row.customer.firstName }} {{ row.customer.lastName }}</span>
        </div>
      </template>

      <template #chargedBy="{ row }">
        <FieldSpan :value="row.chargedBy" :style-to-add="chargedByStyle(row)" />
      </template>

      <template #status="{ row }">
        <FieldSpan :value="row.status" :style-to-add="statusStyle(row)" />
      </template>
    </Table>

    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { formatPrice } from "@estaly/ui/src/utils/price_formatter";
import { Pagination, Table } from "@estaly/ui";
import { isAdminRoute } from "@estaly/ui/src/utils/route";
import FieldSpan from "@/components/utils/FieldSpan.vue";

export default {
  components: { FieldSpan, Table, Pagination },

  props: ["planSales", "currentPage", "totalCount", "totalPages"],

  computed: {
    isAdminRoute,

    columns() {
      const columns = [
        {
          label: "Plan",
          field: "price",
          slot: "plan",
        },
        {
          label: "Produit",
          field: "product",
          slot: "product",
        },
        {
          label: "Client",
          field: "customer",
          slot: "customer",
        },
        {
          label: "Statut",
          field: "status",
          slot: "status",
        },
        {
          label: "Facturé par",
          field: "chargedBy",
          slot: "chargedBy",
        },
      ];

      if (this.isAdminRoute) {
        columns.unshift({
          label: "Magasin",
          field: "salesChannel",
        });
      }

      return columns;
    },
  },

  methods: {
    formatPrice,
    byMonth(planSale) {
      return planSale.monthlyBilling ? "/mois" : "";
    },
    isCancelled(planSale) {
      return planSale.status === "cancelled";
    },

    isExpired(planSale) {
      return planSale.status === "expired";
    },

    isSuspended(planSale) {
      return planSale.status === "suspended";
    },

    statusStyle(planSale) {
      if (this.isCancelled(planSale)) return "text-red-500 bg-red-100 border border-red-300";
      if (this.isExpired(planSale)) return "text-gray-500 bg-gray-100 border border-gray-300";
      if (this.isSuspended(planSale)) return "text-yellow-500 bg-yellow-100 border border-yellow-300";
      return "text-green-500 bg-green-100 border border-green-300";
    },

    chargedByStyle(planSale) {
      return planSale.chargedBy === "Merchant"
        ? "bg-green-100 text-green-800 border border-green-300"
        : "bg-blue-100 text-blue-800 border border-blue-300";
    },

    handleChangePage(newPage) {
      this.$emit("updatePage", newPage);
    },

    redirectToDetails(planSale) {
      const currentRoute = this.$route.path;
      this.$router.push(`${currentRoute}/${planSale.id}`);
    },
  },
};
</script>
